import { IConfig } from ".";

export default {
    env: "production",
    api: "https://api.huismetbenen.nl"
} as IConfig;